import { cloneDeep } from 'lodash-es'
import { IAction, IActionStep } from './action-types';
import { DefaultAction, DefaultLucyAction, DefaultRedirectAddon, DefaultRedirectUrl, DefaultRedirectWidget } from './action-defaults';
import { $L } from '../../../localize';

export function extractAction(action: IAction, basePath?: string) {
    if (!action) return { ...cloneDeep(DefaultAction) }
    if (!basePath) basePath = '$'

    let { type, redirectUrl, redirectWidget, lucyAction, redirectAddOn } = action

    if (type == 'open-url') {
        action.redirectUrl = { ...cloneDeep(DefaultRedirectUrl), ...redirectUrl }
    }
    else if (type == 'open-widget') {
        action.redirectWidget = { ...cloneDeep(DefaultRedirectWidget), ...redirectWidget }
    }
    else if (type == 'execute-action') {
        // get success/error  action
        lucyAction = { ...cloneDeep(DefaultLucyAction), ...lucyAction }
        let { success, error } = lucyAction.postExecution
        let successAction = extractAction(success.action, basePath + '.lucyAction.postExecution.success.action')
        let errorAction = extractAction(error.action, basePath + '.lucyAction.postExecution.error.action')

        lucyAction.postExecution.success.action = successAction
        lucyAction.postExecution.error.action = errorAction
        action.lucyAction = { ...cloneDeep(DefaultLucyAction), ...lucyAction }
    }
    else if (type == 'open-addon') {
        action.redirectAddOn = { ...cloneDeep(DefaultRedirectAddon), ...redirectAddOn }
    }

    return action
}

export function extractActionSteps(action: IAction, basePath?: string, steps?: IActionStep[], name?: string, previousPath?: string) {
    if (!basePath) basePath = "$"
    if (!steps) steps = []
    if (!name) name = $L('widgetdesigner.actions.main-action', 'Main Action')
    if (!previousPath) previousPath = null

    let { type, lucyAction } = action
    steps.push({ name, basePath, action, previousPath })

    if (type == 'execute-action') {
        if (lucyAction && lucyAction.postExecution) {
            let { success, error } = lucyAction.postExecution

            if (!!success && !success.goToHome && success.action) {
                let _steps = extractActionSteps(success.action, `${basePath}.lucyAction.postExecution.success.action`, steps, success.buttonTitle || $L('widgetdesigner.actions.step-success', 'Success'), basePath)
                steps.concat(_steps)
            }

            if (!!error && !error.goToHome && error.action) {
                let _steps = extractActionSteps(error.action, `${basePath}.lucyAction.postExecution.error.action`, steps, error.buttonTitle || $L('widgetdesigner.actions.step-error', 'Error'), basePath)
                steps.concat(_steps)
            }
        }
    }

    return steps
}
